export default async function sleepMillis(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
